export default __webpack_public_path__ + "static/media/avenger.53426c36.jpeg";